import styles from "./style.module.scss";

interface IChipsActivatedMode {
    text: string;
    textColor: string;
    chipColor: string;
    backgroundColor: string;
}

const ChipsActivatedMode = ({ text, textColor, chipColor, backgroundColor }: IChipsActivatedMode) => {
    return (
        <div className={styles["chips-activated-mode"]} style={{ color: textColor, background: backgroundColor }}>
            <div className={styles.chip} style={{ background: chipColor }} />
            {text}
        </div>
    );
};

export default ChipsActivatedMode;
